// components/site-footer.tsx
// components/layout/site-footer.tsx
"use client";

import { Instagram, Linkedin } from "lucide-react";
import Link from "next/link";

export function SiteFooter() {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = [
    {
      title: "Navigation",
      links: [
        { name: "Dashboard", href: "/dashboard" },
        { name: "Conversations", href: "/conversations" },
      ],
    },
    {
      title: "Company",
      links: [
        { name: "About", href: "/about" },
        { name: "Contact", href: "/contact" },
        { name: "Privacy Policy", href: "/privacy" },
        { name: "Terms of Service", href: "/terms" },
      ],
    },
  ];

  const socialLinks = [
    {
      name: "Instagram",
      href: "https://instagram.com/howthef.ai",
      icon: Instagram,
      hoverColor: "hover:text-pink-500"
    },
    {
      name: "LinkedIn", 
      href: "https://linkedin.com/company/howthef",
      icon: Linkedin,
      hoverColor: "hover:text-blue-600"
    },
    // {
    //   name: "X (Twitter)",
    //   href: "https://x.com/howthef_ai", 
    //   icon: Twitter,
    //   hoverColor: "hover:text-gray-900"
    // },
  ];
  
  return (
    <footer className="w-full bg-beige-light ">
      <div className="container mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <Link href="/" className="flex items-center gap-2 mb-4">
              <span className="text-lg font-display font-bold">🤯</span>
              <span className="text-lg font-display font-bold text-gray-900">Fluxos</span>
            </Link>
            
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              AI Agent Conversation Platform
            </p>
          </div>
          
          {/* Footer Links */}
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="text-gray-900 font-display font-semibold mb-3 text-sm">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link 
                      href={link.href} 
                      className="text-gray-600 hover:text-teal text-sm transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        {/* Divider */}
        <div className="border-t border-gray-200 pt-6">
          {/* Bottom Bar */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Copyright */}
            <p className="text-gray-500 text-sm">
              © {currentYear} Fluxos. All rights reserved.
            </p>
            
            {/* Follow Us Section */}
            <div className="flex items-center gap-4">
              <span className="text-gray-600 text-sm font-display font-medium">Follow us</span>
              <div className="flex items-center gap-3">
                {socialLinks.map((social) => {
                  const IconComponent = social.icon;
                  return (
                    <Link
                      key={social.name}
                      href={social.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`text-gray-400 ${social.hoverColor} transition-colors p-1`}
                      aria-label={social.name}
                    >
                      <IconComponent className="h-5 w-5" />
                    </Link>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
